import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("كلمة المرور يجب أن تكون 8 أحرف على الأقل"); return; }
    if (pw !== pw2) { setError("كلمتا المرور غير متطابقتين"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("تم تعيين كلمة المرور بنجاح");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "حدث خطأ — تحقق من صلاحية الرابط");
    } finally { setBusy(false); }
  };

  return (
    <div dir="rtl" className="min-h-screen flex items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md p-8 border shadow-none">
        {done ? (
          <div className="text-center space-y-3" data-testid="reset-success">
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-600" />
            <h1 className="text-xl font-semibold">تم تعيين كلمة المرور ✅</h1>
            <p className="text-sm text-muted-foreground">سيتم تحويلك لصفحة تسجيل الدخول...</p>
            <Link to="/login" className="text-sm text-emerald-700 underline">الذهاب لتسجيل الدخول الآن</Link>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-1">
              <KeyRound className="w-6 h-6 text-emerald-600" />
              <h1 className="text-xl font-semibold">تعيين كلمة مرور جديدة</h1>
            </div>
            <p className="text-sm text-muted-foreground mb-6">أدخل كلمة المرور الجديدة لحسابك في سكول إن.</p>
            {!token && <div className="text-sm text-destructive mb-4" data-testid="reset-no-token">الرابط غير صالح — لا يحتوي على رمز التحقق. اطلب رابطاً جديداً من صفحة تسجيل الدخول.</div>}
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>كلمة المرور الجديدة</Label>
                <Input type="password" value={pw} onChange={e => setPw(e.target.value)} required minLength={8} data-testid="reset-password-input" autoComplete="new-password" />
              </div>
              <div>
                <Label>تأكيد كلمة المرور</Label>
                <Input type="password" value={pw2} onChange={e => setPw2(e.target.value)} required data-testid="reset-password-confirm" autoComplete="new-password" />
              </div>
              {error && <div className="text-sm text-destructive" data-testid="reset-error">{error}</div>}
              <Button type="submit" disabled={busy || !token} className="w-full h-11" data-testid="reset-submit">
                {busy ? "..." : "تعيين كلمة المرور"}
              </Button>
            </form>
            <div className="mt-4 text-center">
              <Link to="/login" className="text-xs text-muted-foreground underline">العودة لتسجيل الدخول</Link>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
